var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUp = function SvgUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-24": 14,
    viewBox: "0 0 14 7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.786 6.521a.78.78 0 0 1-.48-.17l-5.52-4.6-5.52 4.6a.766.766 0 1 1-1-1.16l6-5a.75.75 0 0 1 1 0l6 5a.75.75 0 0 1-.48 1.33"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUp);
export default ForwardRef;